const FontsWeightFoundationsThemes = {
    font_weight_heading_xllm_display_xl_regular: '25rem',
    font_weight_heading_xllm_display_xl_bold: '37.5rem',
    font_weight_heading_xllm_display_1_regular: '25rem',
    font_weight_heading_xllm_display_1_bold: '37.5rem',
    font_weight_heading_xllm_display_2_regular: '25rem',
    font_weight_heading_xllm_display_2_bold: '37.5rem',
    font_weight_heading_xllm_h1_regular: '25rem',
    font_weight_heading_xllm_h1_bold: '37.5rem',
    font_weight_heading_xllm_h2_regular: '25rem',
    font_weight_heading_xllm_h2_bold: '37.5rem',
    font_weight_heading_s_display_xl_regular: '18.75rem',
    font_weight_heading_s_display_xl_bold: '25rem',
    font_weight_heading_s_display_1_regular: '18.75rem',
    font_weight_heading_s_display_1_bold: '25rem',
    font_weight_heading_s_display_2_regular: '18.75rem',
    font_weight_heading_s_display_2_bold: '25rem',
    font_weight_heading_s_h1_regular: '25rem',
    font_weight_heading_s_h1_bold: '37.5rem',
    font_weight_heading_s_h2_regular: '25rem',
    font_weight_heading_s_h2_bold: '37.5rem',
    font_weight_heading_title_ds_bold: '37.5rem',
    font_weight_heading_title_ds_light: '18.75rem',
    font_weight_paragraph_large_regular: '25rem',
    font_weight_paragraph_large_bold: '37.5rem',
    font_weight_paragraph_medium_regular: '25rem',
    font_weight_paragraph_medium_bold: '37.5rem',
    font_weight_paragraph_small_regular: '25rem',
    font_weight_paragraph_small_bold: '37.5rem',
    font_weight_caption_medium_regular: '25rem',
    font_weight_caption_medium_bold: '37.5rem',
    font_weight_caption_small_regular: '25rem',
    font_weight_caption_small_bold: '37.5rem',
    font_light: 300,
    font_regular: 400,
    font_weight_600: 600,
    font_bold: 700,
};
export { FontsWeightFoundationsThemes };
//# sourceMappingURL=fonts-weight-foundations.themes.js.map